import { default as GroupBy } from "./GroupBy";
import { default as ProjectTitle } from "./ProjectTitle";

export default {
  GroupBy,
  ProjectTitle,
};
